import Tooltip from '@anm/components/Tooltip';
import { InfoLabel } from '@anm/styles/helpers';
import { FC } from 'react';

import { ChartTitle, ChartTitleWrapper, TitleRow } from '../Wrapper';
import { AnalyticsTabProps } from '../types';

import PreviewBlock from './PreviewBlock';
import { EngagementContent } from './Wrapper';
import { useEngagementVideoData } from './hooks';

const EngagementChart: FC<AnalyticsTabProps> = props => {
  const [videoProps, averageViews, renderTooltipContent] = useEngagementVideoData();

  return (
    <EngagementContent>
      <TitleRow maxWidth={videoProps.chartSizes.width}>
        <ChartTitleWrapper>
          <ChartTitle title="Engagement" level={4} />
          <Tooltip direction="to-top" renderContent={renderTooltipContent}>
            <InfoLabel />
          </Tooltip>
        </ChartTitleWrapper>
        {!!averageViews && <span>{averageViews.toFixed(2)}%</span>}
      </TitleRow>
      <PreviewBlock isDataExist={averageViews > 0} {...{ ...props, ...videoProps }} />
    </EngagementContent>
  );
};

export default EngagementChart;
